import { api } from "./axios";

export const getLocationInfo = (
  pincode: string
): Promise<{ pincode: string; state: string; city: string }> => {
  return api.get(`metadata/locations/${pincode}/`);
};
